import { LivingRoomKitchenSpecification } from '../../LivingRoomKitchenSpecification';

type GetLivingRoomKitchenSpecificationWidth = (
  roomSpecification: LivingRoomKitchenSpecification
) => number;
export const getLivingRoomKitchenSpecificationWidth: GetLivingRoomKitchenSpecificationWidth = (
  roomSpecification
) => roomSpecification.defaultWidth;
